import React from 'react';

import clsx from 'clsx';
import { useSelector } from 'react-redux';

import { RootState } from 'actions';
import FormBody from 'components/FormBody';
import FormHeader from 'components/FormHeader';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';

import styles from './Congratulations.module.scss';

const Congratulations = () => {
  const mainContactFirstName = useSelector(
    (state: RootState) => state.contractorPortal.contractorApplication?.intermediary_main_contact_first_name,
  );
  const companyName = useSelector(
    (state: RootState) => state.contractorPortal.contractorApplication?.intermediary_business_name,
  );
  const { csm } = useSelector((state: RootState) => state.contractorPortal);

  return (
    <>
      <FormHeader title="Congratulations!" percent={ProgressBarStatus.Done} classNameTitle={styles.form_title} />
      <FormBody>
        <h2 className={styles.header}>
          {`${mainContactFirstName}, you are now ready to offer HFS to your customers.\nWe are excited to start working with ${companyName}.`}
        </h2>

        <p className={clsx('body_text--alternative', styles.section)}>
          You were just sent an email from <span className={styles.processor_name}>{csm?.name}</span> with your
          dedicated consumer application link. Installing this link on your website is easy. When customers click the
          link to apply, you will be emailed status updates on their loan process.
        </p>

        <p className="body_text--alternative">
          Lastly, your dedicated HFS Manager will contact you shortly to ensure you are properly onboarded.
        </p>
      </FormBody>
    </>
  );
};

export default Congratulations;
